































import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'

import Vue from 'vue'
import BasePageTemplate from '@/views/templates/africadogs/BasePageTemplate.vue'
import TalkArea from '@/views/molecules/TalkAreaAfricaDogs.vue'
import ScrollFire from '@/views/mixin/ScrollFire'

Vue.mixin(ScrollFire)

export default
  components: {
    EpisodeTitle
    BasePageTemplate
    TalkArea
  }

  data: () ->
    labels: [
      {
        image: '/assets/image/africadogs/illust_nakasuup1.png'
        name: '中須さん'
        text: [
          'やぁスーさん、AFURIKA DOGSへようこそ！'
          '僕は、遠く離れたアフリカ大陸と日本をつなごうと奔走している、代表の中須です。'
        ]
      }
      {
        image: '/assets/image/africadogs/illust_nakasuup2.png'
        name: '中須さん'
        text: [
          'アフリカでは、クリスマスや誕生日、結婚式などに、マルシェで鮮やかなアフリカ布を買って、自分だけの服を仕立ててもらうんだよ。'
          'ハレの日を彩るファッションの在り方がとっても素敵だって思ったんだ！'
        ]
      }
      {
        image: '/assets/image/africadogs/illust_nakasuup1.png'
        name: '中須さん'
        text: [
          'AFURIKA DOGSでもオーダーメイドやセミオーダーで服を仕立てるサービスもやっているんだよ。'
          'さらに京都の職人さんの染色技術が集約された、オリジナルの服も扱っているからあとで紹介するよ！'
        ]
      }
    ]
    fire_scroll: true

  created: () ->
    @$options.scroll_target = '.episode0'

  methods: {
    startScrollFire: (e) ->
      @$emit('startScrollFire')
  }

